exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".details[data-v-153840cf]{font-size:.7rem;height:10px;font-weight:700}", ""]);

// exports
